import "../Navigation/Navigation.js";

document.addEventListener('DOMContentLoaded', (event) => {
    const pageHeader = document.querySelector('.layout-page-header');
    let oldstate = window.pageYOffset;
    if (window.pageYOffset > 0) {
        pageHeader.setAttribute("class", "layout-page-header scrolled");
    }
    document.addEventListener('scroll', scroll => {
        let newstate = window.pageYOffset;
        let changed = oldstate !== newstate;
        if (changed && window.pageYOffset > 0 && window.pageYOffset <= 100) {
            oldstate = newstate;
            pageHeader.setAttribute("class", "layout-page-header scrolled");
        } else if (changed && window.pageYOffset > 100) {
            if (newstate < oldstate) {
                oldstate = newstate;
                if(document.querySelector('body').classList.contains('blogdetailpage') && window.location.hash !== '' && localStorage.getItem('blog-toc-clicked')) {
                    pageHeader.setAttribute("class", "layout-page-header scrolled hide");
                    setTimeout(() => {
                        localStorage.removeItem('blog-toc-clicked')
                    }, 3000)
                } else {
                    pageHeader.setAttribute("class", "layout-page-header scrolled show");
                }
            } else {
                oldstate = newstate;
                pageHeader.setAttribute("class", "layout-page-header scrolled hide");
            }
        } else if(changed && window.pageYOffset == 0) {
            oldstate = newstate;
            document.getElementsByClassName("layout-page-header scrolled")[0].setAttribute("class", "layout-page-header scrolled-to-top");
        }
    }, true);

    const $_navToggler = document.querySelector('.app-site-burger.hamburger--collapse');

    $_navToggler.addEventListener('click', function() {
        this.classList.toggle('is-active');
        document.querySelector('.app-site-navigation').classList.toggle('is-active');
        document.querySelector('.header-navigation').classList.toggle('is-active');
        document.querySelector('main').classList.toggle('mobile-menu-is-active');
        document.querySelector('.mobile-burger').previousSibling.classList.toggle('hide');
    });

    //Triggering digiaccess buttons
    function afTriggeringDigiAccess() {
        const digiaccessDialog = document.getElementById("digiAccess");
        const digiAccessButtonOpen = document.getElementById("dAopener");
        const digiAccessButtonClose = document.getElementById("da_close");
        if (digiAccessButtonOpen && digiaccessDialog.dataset.daVisible === "false") {
            //In case digiaccess open button exists and the dialog is closed
            digiAccessButtonOpen.click();
        }
        else if (digiAccessButtonClose && digiaccessDialog.dataset.daVisible === "true") {
            //In case digiaccess close button exists and the dialog is open
            digiAccessButtonClose.click();
        }
    }
    //Triggering digiaccess open on click on custom buttons

    //In the desktop header
    document.getElementById("af-digiaccess-trigger").addEventListener("click",afTriggeringDigiAccess);
    //In the mobile header
    document.getElementById("af-digiaccess-trigger-mobile").addEventListener("click",afTriggeringDigiAccess);
    //In the pwa menu
    document.getElementById("af-pwa-sub-menu-digiaccess").addEventListener("click",afTriggeringDigiAccess);
})
